<template>
  <div>
    <h3>Your DDDI Application Has Been Saved</h3>
    <p>
      Your DDDI application has been saved.
    </p>
  </div>
</template>

<script>
export default {
  name: 'DDDIApplicationSaved',
  props: ['projectType'],
  computed: {
    applicationNumber() {
      if (Object.prototype.hasOwnProperty.call(this.$route.query, 'applicationId') && this.$route.query.applicationId) {
        return this.$route.query.applicationId;
      }
      return '';
    },
  },
};
</script>
